module.exports = __webpack_public_path__ + "img/desktop_person3.ec2b4fab.svg";